import { PERSONAL_API_KEYS_COLUMN_ID } from "../constants";
import PersonalApiKeysTableDropdownCell from "./DropdownCell";
import PersonalApiKeysTableExpiresAtCell from "./ExpiresAtCell";
import PersonalApiKeysTableKeyIdCell from "./KeyIdCell";
import PersonalApiKeysTableLastUsedCell from "./LastUsedCell";
import PersonalApiKeysTableNameCell from "./NameCell";

export const PERSONAL_API_KEYS_TABLE_CELLS = {
  [PERSONAL_API_KEYS_COLUMN_ID.NAME]: PersonalApiKeysTableNameCell,
  [PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: PersonalApiKeysTableKeyIdCell,
  [PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: PersonalApiKeysTableExpiresAtCell,
  [PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: PersonalApiKeysTableLastUsedCell,
  [PERSONAL_API_KEYS_COLUMN_ID.DROPDOWN]: PersonalApiKeysTableDropdownCell,
};
